import { render, staticRenderFns } from "./ProfileCropper.vue?vue&type=template&id=2bf49d2a&"
import script from "./ProfileCropper.vue?vue&type=script&lang=js&"
export * from "./ProfileCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports